import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import axios from 'axios';

const ProductDetailReviews = ({ contentData }) => {
  return (
    <>
      <div className='col-sm-12 py-3 px-0 m-b-30 review-detail-section justify-content-md-center'>
        <div
          data-bv-show='reviews'
          data-bv-product-id={`${contentData?.partNumber}-${contentData?.skus[0]?.partnumber}`}
        ></div>
      </div>
    </>
  );
};
export default ProductDetailReviews;
